import React, { useState } from 'react';
import useGetUsers from '../../../../hooks/getUsers';
import Loader from '../../../loader';
import CustomAlert from '../../../customAlert';
import VpAdminVerkstedCard from '../../../VP/verkstedCards';
import VPaNettbutikkCSS from '../nettbutikk/vpAdminNettbutikk.module.css';
import FormModal from '../../../formModal';
import AddVerkstedForm from '../../../VP/addVerksted';
// import searchObject from '../../../../helpers/searchFunctionality';
import verkstedsCss from './verksteder.module.css';
import { filterObjects } from '../../../../helpers/searchFunctionality';


export function VPVerkstedSide() {

    const { users, isLoading, isError} = useGetUsers();
    const [searchText, setSearchText] = useState('');

    let verksteder = users;

    if(isLoading || !verksteder) {
        return(
            <div><Loader /></div>
        )
    }

    if(isError) {
        return(
            <div>
                <CustomAlert 
                    message="Oida, her gikk noe galt! Vennligst prøv igjen!"
                />
            </div>
        )
    }

    // const filteredVerksteder = users.filter(verksted => searchObject(verksted, searchText));

    const filteredVerksteder = filterObjects(searchText, verksteder);

    verksteder.sort((a, b) => {
        const usernameA = a.username.toUpperCase();
        const usernameB = b.username.toUpperCase();

        if(usernameA < usernameB) {
            return -1;
        }
        if(usernameA > usernameB) {
            return 1;
        }
        return 0;
    });

    const handleSearchInputChange = (e) => {
        setSearchText(e.target.value);
    }

    return(
        <div>
            <h1>ALLE VERKSTEDER</h1>
            <input 
                type="text"
                placeholder='Søk...'
                value={searchText}
                onChange={handleSearchInputChange}
            />
            <div className={verkstedsCss.container1}>
                <div className={verkstedsCss.container2}>
                    <div className={VPaNettbutikkCSS.subContainer1}>
                        <FormModal 
                            buttonTitle="Legg til verksted"
                            body={<AddVerkstedForm />}
                            modalTitle="Legg til verksted"
                            openButtonClass={VPaNettbutikkCSS.openButton}
                            closeButtonClass={VPaNettbutikkCSS.closeButton}
                        />
                    </div>
                    <div className={VPaNettbutikkCSS.subContainer2}>
                        <p>Her vil det også komme filter</p>
                    </div>
                </div>
                <div className={verkstedsCss.container3}>
                    {filteredVerksteder.map((verksted) => (
                        <div key={verksted.id} className={verkstedsCss.cardContainer}>
                            <VpAdminVerkstedCard key={verksted.id} verksted={verksted} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default VPVerkstedSide;